import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';

/**
 * User profile page — view/edit display name, see role, sign out.
 */
export default function ProfilePage() {
  const { user, profile, displayName, isAdmin, signOut, updateProfile, isLocalMode } = useAuth();
  const [editName, setEditName] = useState(displayName);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');
  const navigate = useNavigate();

  const handleSave = async () => {
    if (!editName.trim() || editName === displayName) return;
    setSaving(true);
    const { error } = await updateProfile({ display_name: editName.trim() });
    setSaving(false);
    setMessage(error ? error.message : 'Profile updated!');
    setTimeout(() => setMessage(''), 3000);
  };

  const handleSignOut = async () => {
    await signOut();
    navigate('/login');
  };

  if (isLocalMode) {
    return (
      <div className="max-w-lg mx-auto px-4 py-8 text-center">
        <h2 className="text-xl font-bold text-white mb-4">Local Mode</h2>
        <p className="text-gray-400">No user account — running with localStorage only.</p>
      </div>
    );
  }

  return (
    <div className="max-w-lg mx-auto px-4 py-8">
      <h2 className="text-xl font-bold text-white mb-6">Profile</h2>

      <div className="bg-gray-800 rounded-xl border border-gray-700 p-6 mb-6">
        <div className="mb-4">
          <label className="block text-sm text-gray-400 mb-1">Display Name</label>
          <div className="flex gap-2">
            <input
              type="text"
              value={editName}
              onChange={(e) => setEditName(e.target.value)}
              className="flex-1 px-3 py-2 rounded-lg bg-gray-700 border border-gray-600 text-white"
            />
            <button
              onClick={handleSave}
              disabled={saving || editName === displayName}
              className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 text-sm"
            >
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
          {message && (
            <p className="text-sm text-green-400 mt-2">{message}</p>
          )}
        </div>

        <div className="mb-4">
          <label className="block text-sm text-gray-400 mb-1">Email</label>
          <p className="text-white">{user?.email}</p>
        </div>

        <div className="mb-4">
          <label className="block text-sm text-gray-400 mb-1">Role</label>
          <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${
            isAdmin ? 'bg-purple-900/50 text-purple-300' : 'bg-gray-700 text-gray-300'
          }`}>
            {isAdmin ? 'Admin' : 'Member'}
          </span>
        </div>

        <div>
          <label className="block text-sm text-gray-400 mb-1">Member Since</label>
          <p className="text-gray-300 text-sm">
            {profile?.created_at ? new Date(profile.created_at).toLocaleDateString() : '—'}
          </p>
        </div>
      </div>

      <button
        onClick={handleSignOut}
        className="w-full py-2.5 bg-red-900/50 text-red-400 rounded-lg hover:bg-red-900 font-medium"
      >
        Sign Out
      </button>
    </div>
  );
}
